import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useMarkNotificationRead } from '@/hooks/mutations/use-mark-notification-read';
import { useNotificationCenterStore } from '@/stores/notification-center-store';
import { NotificationItem } from '@/types/notification-types';
import { isSafeHttpUrl, openExternalUrl } from '@/utils/url-utils';
import { getNotificationTarget } from './helpers/get-notification-target';

export const useOpenNotification = () => {
  const navigate = useNavigate();
  const close = useNotificationCenterStore((s) => s.close);
  const markRead = useMarkNotificationRead();

  // `target` overrides the notification's own destination, for a member of a
  // batched notification (one run out of several) that has its own link.
  return useCallback(
    (notification: NotificationItem, target?: string | null) => {
      if (!notification.read_at) {
        markRead.mutate(notification.id);
      }
      const destination = target ?? getNotificationTarget(notification);
      if (!destination) return;
      if (isSafeHttpUrl(destination)) {
        openExternalUrl(destination);
      } else {
        navigate(destination);
        close();
      }
    },
    [navigate, close, markRead],
  );
};
